(function () {
  'use strict';

  angular
    .module('neo.home.matches')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('home.matches', {
        url: '/matches',
        templateUrl: 'home/matches/matches.tpl.html',
        data: {
          townHall: undefined,
          initDate: undefined,
          endDate: undefined
        },
        controller: 'MatchesCtrl',
        controllerAs: 'vm',
        resolve: {
          townHalls: function (Ajuntaments) {
            return Ajuntaments.query().$promise;
          },
          currentSeason: function(CurrentSeason) {
            return CurrentSeason.get().$promise;
          }
        }
      });
  }
}());
